<template>
	<div class="order-rejected-dialog">
		<h2 class="order-rejected-dialog__heading">
			Sorry, your order #{{ notification.data.order_number }} was rejected by Glaze.
		</h2>

		<p class="order-rejected-dialog__description">
			Please contact
			<a href="mailto:hello@glazeprosthetics.com" target="_blank">hello@glazeprosthetics.com</a>
			to understand what was the problem with the order.
		</p>

		<div class="order-rejected-dialog__buttons">
			<base-button :loading="isLoading" @click="confirm">Ok, close</base-button>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { NotificationModel } from '@/store/models/Notification';
import { notificationActions } from '@/store/modules/notification/actions';

export default defineComponent({
	props: {
		close: {
			type: Function,
			required: true,
		},

		notification: {
			type: Object as PropType<NotificationModel>,
			required: true,
		},
	},

	computed: {
		isLoading(): boolean {
			return this.$isLoading([`notification/markNotificationAsRead/${this.notification.id}`]);
		},
	},

	methods: {
		async confirm() {
			try {
				await notificationActions.markNotificationAsRead(this.notification.id);
				this.close();
			} catch {
				this.$toast.open({
					message: 'Could not mark notification as read. Try again later.',
				});
			}
		},
	},
});
</script>

<style lang="scss">
.order-rejected-dialog {
	color: $color-gray;

	&__heading {
		@include heading-2;
		margin-bottom: 2.8rem;
		word-break: break-word;
	}

	&__description {
		a {
			color: inherit;
			text-decoration: none;
			transition-property: color, border;
			opacity: 1;
			border-bottom: 1px solid transparent;

			&:hover {
				color: $color-primary;
				border-bottom-color: currentColor;
			}
		}
	}

	&__buttons {
		display: flex;
		justify-content: center;
		margin-top: 5.2rem;

		.base-button {
			min-width: 14rem;
			min-height: 5.6rem;
		}
	}
}
</style>
